import { BookOpenIcon, SwitchHorizontalIcon } from '@heroicons/react/outline';
import {
  BanIcon,
  CheckIcon,
  ThumbUpIcon,
  UserIcon,
} from '@heroicons/react/solid';

export default function RecentActivities({ activity }: { activity: any }) {
  return (
    <>
      <section
        aria-labelledby="timeline-title"
        className="lg:col-start-3 lg:col-span-1 w-1/2 mt-20 h-96 overflow-y-auto">
        <div className="bg-white shadow sm:rounded-lg divide-y ">
          <div className="py-5">
            <h2
              id="timeline-title"
              className="text-lg px-6 py-2 font-medium text-gray-900 m-0 border-l-4 border-primaryColor-normal text-primaryColor-normal">
              Timeline
            </h2>
          </div>

          {/* Activity Feed */}
          <div className="py-6 flow-root px-6">
            <ul className="-mb-8">
              {activity?.map((item: any, itemIdx: number) => (
                <li key={item.id}>
                  <div className="relative pb-8">
                    {itemIdx !== activity?.length - 1 ? (
                      <span
                        className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-cyan-normal"
                        aria-hidden="true"
                      />
                    ) : null}
                    <div className="relative flex space-x-3">
                      <div>
                        <span
                          className={
                            'h-8 w-8 bg-cyan-normal rounded-full flex items-center justify-center ring-8 ring-white'
                          }></span>
                      </div>
                      <div className="min-w-0 flex-1 pt-1.5">
                        <div>
                          <p className="text-sm">{item?.content} </p>
                        </div>
                        <div className="flex justify-between text-sm text-gray-500 mt-2">
                          <time
                            dateTime={item?.date}
                            className="capitalize text-xs">
                            {item?.by}
                          </time>
                          <time dateTime={item?.date} className="text-xs">
                            {item?.date}
                          </time>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
